import React from 'react';
import { IconLink } from '../../index';

import styles from './social-media-links.module.scss';

const baseClass = 'social-media-links';

export type SocialMediaType = 'twitter' | 'facebook' | 'instagram' | 'tiktok' | 'linkedin' | 'youtube';
export type SocialMediaNavigationItem = {
  type: SocialMediaType;
  href: string;
  rel?: string;
  target?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

export const SocialMediaNavigation: React.FC<{
  ariaLabel: string;
  items: SocialMediaNavigationItem[];
}> = ({ ariaLabel, items }) => (
  <div className={styles[baseClass]} aria-label={ariaLabel}>
    <ul className={styles[`${baseClass}__list`]}>
      {items.map((item, index) => (
        <li key={`${item.type}-${index}`} className={styles[`${baseClass}__item`]}>
          <IconLink
            icon={{ name: `${item.type}--small`, 'aria-hidden': true }}
            {...item}
            aria-label={item.type}
            variant="hyperlink"
          />
        </li>
      ))}
    </ul>
  </div>
);
